import type { CompetitorRecord } from "@/lib/compare/types";

const PRICING = "https://www.opus.pro/pricing";
const CHECKED = "2026-10-08";

export const OPUS_CLIP: CompetitorRecord = {
  slug: "opus-clip",
  name: "Opus Clip",
  aliases: ["OpusClip", "Opus Pro", "opus.pro"],
  url: "https://www.opus.pro",
  pricingUrl: PRICING,
  category: "clipper",
  positioning: "AI clipping tool that turns long videos into short clips with a virality score.",
  plans: [
    {
      name: "Free",
      monthly: 0,
      metered: "60 credits per month, 1 credit per source minute",
      includes: [
        "Watermark on exports",
        "No editing",
        "Clips stop being exportable after 3 days",
        "Up to 1080p",
      ],
      sourceUrl: PRICING,
      checkedAt: CHECKED,
    },
    {
      name: "Starter",
      monthly: 15,
      metered: "150 credits per month, 1 credit per source minute",
      includes: [
        "Monthly billing only, no annual option",
        "No watermark",
        "AI captions in 20+ languages",
        "1 brand template",
        "3 AI B-roll clips and 3 stock B-roll clips per month",
        "Media expires after 29 days",
      ],
      sourceUrl: PRICING,
      checkedAt: CHECKED,
      note: "The pricing page states the Starter plan is only available monthly.",
    },
    {
      name: "Pro",
      monthly: 29,
      annualPerMonth: 14.5,
      annualTotal: 174,
      metered: "300 credits per month, unused credits roll over for 2 months",
      includes: [
        "Team workspace with 2 seats",
        "Scheduler to 6 social connections",
        "Video Editing API, Scheduler API, MCP connector, Zapier",
        "100 GB storage",
      ],
      sourceUrl: PRICING,
      checkedAt: CHECKED,
    },
    {
      name: "Business",
      custom: true,
      metered: "Custom credits",
      includes: ["Unlimited seats and storage", "SSO", "4K download is Business-only"],
      sourceUrl: PRICING,
      checkedAt: CHECKED,
    },
  ],
  entryPlanName: "Starter",
  entryPlanIncludes: "150 credits, which is 150 minutes of uploaded video, monthly billing only",
  freeTier: "60 credits a month with a watermark, no editing, and clips that expire after 3 days",
  trial: "7-day Pro trial with 90 credits on signup",
  meteringUnit: "1 credit per source minute uploaded, whatever you keep",
  exportResolution: "1080p on Free through Pro, 4K on Business only",
  features: {
    longToShort: { v: "yes", note: "ClipAnything" },
    momentRanking: { v: "yes", note: "Virality Score" },
    reframing: { v: "yes", note: "ReframeAnything object tracking" },
    maxSource: { v: "text", note: "Size caps only: 10 GB free, 30 GB paid" },
    layouts: { v: "n/a", note: "Not enumerated on the pricing page" },
    redditStory: { v: "no" },
    fakeText: { v: "no" },
    aiImages: { v: "partial", note: "AI image B-roll only" },
    voiceover: { v: "partial", note: "20 per day on paid plans" },
    voiceCloning: { v: "n/a" },
    avatars: { v: "n/a" },
    timelineEditor: { v: "partial", note: "Paid plans only, Free has no editing" },
    captionStyles: { v: "n/a", note: "Count not published" },
    captionLanguages: { v: "text", note: "20+" },
    bRoll: { v: "yes", note: "Metered: 3 per month on Starter" },
    fourK: { v: "partial", note: "Business plan only" },
    scheduling: { v: "yes", note: "6 networks on Pro" },
    analytics: { v: "partial", note: "Described as upcoming" },
    socialTracker: { v: "no" },
    api: { v: "yes", note: "Pro and up, with MCP and SDKs" },
    webhooks: { v: "n/a" },
    web: { v: "yes" },
    desktop: { v: "no" },
    mobile: { v: "no", note: "Not advertised" },
    teamSeats: { v: "yes", note: "2 seats per Pro pack" },
    freeTier: { v: "yes", note: "Watermark, no editing, 3-day expiry" },
    trial: { v: "yes", note: "7 days of Pro" },
    metering: { v: "text", note: "1 credit per source minute" },
    rollover: { v: "partial", note: "Pro only, 2 months" },
    refunds: { v: "text", note: "Not stated on the pricing page" },
    cancelInApp: { v: "n/a", note: "Not stated on the pricing page" },
  },
  billingTerms: {
    refunds: "No refund terms appear on the pricing page as of Oct 8, 2026.",
    cancel: "Cancellation steps are not described on the pricing page.",
    sourceUrl: PRICING,
    checkedAt: CHECKED,
  },
  quotes: [
    {
      text: "16 emails to cancel and they're still trying to charge me",
      date: "2026-09-26",
      url: "https://www.trustpilot.com/review/opus.pro",
      evidences: "cancelInApp",
    },
    {
      text: "every time you turn around, they want you to buy more credits",
      date: "2026-10-06",
      url: "https://www.trustpilot.com/review/opus.pro",
      evidences: "metering",
    },
  ],
  verification: {
    method: "fetch",
    date: CHECKED,
    note: "Pricing page fetched directly. Annual Pro figure ($14.50/mo, $174/yr) read from the page's own script, which also lists regional tiers of $138 and $114.",
  },
  seoPattern: "opus.pro/<competitor>-alternative, no page about Crayo",
};
